import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  procedureTemplateService,
  type CreateStepDto,
  type UpdateStepDto,
  type MaterialType,
} from '@/services/procedure-template.service';
import { procedureKeys } from './useProcedureTemplates';

export function useCreateStep(templateId: string, sectionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreateStepDto) =>
      procedureTemplateService.createStep(templateId, sectionId, dto),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: procedureKeys.detail(templateId) });
    },
  });
}

export function useUpdateStep(templateId: string, sectionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ stepId, dto }: { stepId: string; dto: UpdateStepDto }) =>
      procedureTemplateService.updateStep(templateId, sectionId, stepId, dto),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: procedureKeys.detail(templateId) });
    },
  });
}

export function useDeleteStep(templateId: string, sectionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (stepId: string) =>
      procedureTemplateService.deleteStep(templateId, sectionId, stepId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: procedureKeys.detail(templateId) });
    },
  });
}

export function useReorderSteps(templateId: string, sectionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (orderedIds: string[]) =>
      procedureTemplateService.reorderSteps(templateId, sectionId, orderedIds),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: procedureKeys.detail(templateId) });
    },
  });
}

export function useUploadRefMaterial(templateId: string, sectionId: string, stepId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ file, materialType }: { file: File; materialType: MaterialType }) =>
      procedureTemplateService.uploadRefMaterial(templateId, sectionId, stepId, file, materialType),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: procedureKeys.detail(templateId) });
    },
  });
}

export function useDeleteRefMaterial(templateId: string, sectionId: string, stepId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (materialId: string) =>
      procedureTemplateService.deleteRefMaterial(templateId, sectionId, stepId, materialId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: procedureKeys.detail(templateId) });
    },
  });
}
